import React from 'react'
import { ImageField, ImageInput, InputProps } from 'react-admin'

export type ImageInputProps = Pick<InputProps, 'validate'> & {
  label?: string
  accept?: string
  source?: 'image'
}

const SingleImageInput: React.FC<ImageInputProps> = ({
  label = 'form.fields.newImage',
  accept = '.jpeg, .jpg',
  source = 'image',
  validate = [],
}) => {
  return (
    <ImageInput
      source={source}
      maxSize={5000000}
      label={label}
      accept={accept}
      validate={validate}
    >
      <ImageField
        source="src"
        sx={{ '& .RaImageField-image': { width: '150px' } }}
      />
    </ImageInput>
  )
}

export default SingleImageInput
